import { useState } from 'react'
import {
  LoginModalConsumer,
  LoginModalProvider,
} from '../../Login/context/LoginModalContext'
import AddToGarageModal from './AddToGarageModal'
import { errorToast } from '../../lib/toastAlert'
import { useI18nReady } from '../../hooks/useI18nReady'

export default function AddToGarage({ mobile }) {
  const i18nReady = useI18nReady()
  const [isGarageModalOpen, setGarageModalOpen] = useState(false)

  if (!i18nReady) return null

  const alertCannotAdd = () => {
    errorToast({ title: 'It is not yet possible to add auction to Garage' })
  }

  return (
    <LoginModalProvider>
      <LoginModalConsumer>
        {({ openLoginModal }) =>
          App.State.userSignedIn ? (
            <SignedInButton
              openGarageModal={() => setGarageModalOpen(true)}
              alertCannotAdd={alertCannotAdd}
              mobile={mobile}
            >
              {App.State.published && (
                <AddToGarageModal
                  modalIsOpen={isGarageModalOpen}
                  carId={App.State.carId}
                  closeGarageModal={() => setGarageModalOpen(false)}
                />
              )}
            </SignedInButton>
          ) : (
            <NotSignedInButton openLoginModal={openLoginModal} mobile={mobile}>
              {App.State.published && (
                <AddToGarageModal
                  modalIsOpen={isGarageModalOpen}
                  carId={App.State.carId}
                  closeGarageModal={() => setGarageModalOpen(false)}
                />
              )}
            </NotSignedInButton>
          )
        }
      </LoginModalConsumer>
    </LoginModalProvider>
  )
}

function SignedInButton({ mobile, openGarageModal, alertCannotAdd, children }) {
  return (
    <>
      <button
        type="button"
        className={`btn ${
          mobile ? 'btn-light' : 'btn-white'
        } ga-event d-flex align-items-center justify-content-center rounded-8`}
        id={mobile ? 'add-to-garage-button' : 'add-to-garage-mobile'}
        style={{ height: '100%' }}
        data-ga-event={JSON.stringify({
          category: 'Car Page',
          action: 'Click Garage',
        })}
        title={I18n.t('garage.add_to_garage')}
        aria-label={I18n.t('garage.add_to_garage')}
        onClick={App.State.published ? openGarageModal : alertCannotAdd}
      >
        <i className={`far fa-star fa-lg${mobile ? '' : ' text-neutral'}`} />
      </button>
      {children}
    </>
  )
}

function NotSignedInButton({ mobile, openLoginModal, children }) {
  return (
    <>
      <button
        type="button"
        className={`btn ${
          mobile ? 'btn-light' : 'btn-white text-muted'
        } ga-event w-100 d-flex align-items-center justify-content-center text-nowrap`}
        id={mobile ? 'add-to-garage-button' : 'add-to-garage-mobile'}
        style={{ height: '100%' }}
        onClick={() => openLoginModal()}
        data-ga-event={JSON.stringify({
          category: 'Car Page',
          action: 'Click Garage',
        })}
        title={I18n.t('garage.add_to_garage')}
        aria-label={I18n.t('garage.add_to_garage')}
      >
        <i className={`far fa-star fa-lg ${mobile ? '' : ' text-neutral'}`} />
        { !mobile && <span>{` ${I18n.t('save')}`}</span> }
      </button>
      {children}
    </>
  )
}
